module.exports = __webpack_public_path__ + "fonts/18f2cd0.eot";